import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "../components/Reveal";

const FRAGEN = [
  {
    q: "Meine Zielgruppe ist sehr speziell. Funktioniert das trotzdem?",
    a: "Gerade dann. Je kleiner und klarer Ihre Zielgruppe ist, desto vollständiger können wir sie erreichen. In der Zielgruppen-Analyse filtern wir sie gemeinsam und Sie sehen die Zahl."
  },
  {
    q: "Ist das nicht Spam?",
    a: "Nein. Wir sprechen wenige hundert vorab geprüfte Personen persönlich an, nicht Tausende mit derselben Nachricht. Jede Nachricht geht unter Ihrem Namen raus und ist mit Ihnen abgestimmt."
  },
  {
    q: "Wie viel Zeit muss ich selbst investieren?",
    a: "Im ersten Monat vier Termine, in denen wir gemeinsam alles aufsetzen. Danach steuern Sie die Kampagne mit einem Termin von 45 Minuten im Monat. Profil, Content und Ansprache übernehmen wir, Ihre Zeit geht in die Gespräche mit interessierten Entscheidern."
  },
  {
    q: "Ich habe LinkedIn schon selbst probiert. Was ist anders?",
    a: "Meist fehlen eine sauber eingegrenzte Zielgruppe und tägliche, konsequente Arbeit daran. Genau das ist unsere Aufgabe."
  },
  {
    q: "Wie schnell kommen die ersten Gespräche?",
    a: "Der erste Monat ist das Onboarding, danach startet die Kampagne. Rechnen Sie insgesamt mit zwei bis drei Monaten bis zu den ersten regelmäßigen Gesprächen. Deshalb arbeiten wir mit Laufzeiten ab sechs Monaten."
  },
  {
    q: "Was kostet die Zusammenarbeit?",
    a: "Ab 3.000 € im Monat, Laufzeit ab sechs Monaten. Den genauen Rahmen klären wir, wenn wir Ihre Zielgruppe kennen."
  },
  {
    q: "Warum ist die Zielgruppen-Analyse kostenfrei?",
    a: "Weil wir nur mit Unternehmen arbeiten, bei denen es passt. Die Analyse zeigt uns beiden, ob das so ist."
  }
];

export default function Faq() {
  const [offen, setOffen] = useState(-1);

  return (
    <section className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-navy/40" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">Häufige Fragen</p>
          </div>
        </Reveal>

        <div className="mt-10 divide-y divide-navy/10 border-b border-t border-navy/10">
          {FRAGEN.map((f, i) => (
            <div key={f.q} data-testid={`faq-item-${i + 1}`}>
              <button
                type="button"
                data-testid={`faq-button-${i + 1}`}
                onClick={() => setOffen(offen === i ? -1 : i)}
                aria-expanded={offen === i}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
              >
                <span className="text-base font-medium text-textdunkel sm:text-lg">{f.q}</span>
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-navy/15 text-textgrau transition-transform duration-300 ${offen === i ? "rotate-180" : ""}`}>
                  <ChevronDown size={15} />
                </span>
              </button>
              {offen === i && (
                <p className="pb-6 pr-12 text-sm leading-[1.8] text-textgrau sm:text-base" data-testid={`faq-antwort-${i + 1}`}>
                  {f.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
